import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { unidades } from "@/constants/unidades";

export function FilterUnidade({ onChange, value }) {
  return (
    <Select
      value={value || ""}
      onValueChange={(val) => onChange(val === "all" ? "" : val)}
    >
      <SelectTrigger className="w-[200px]">
        <SelectValue placeholder="Filtrar unidade" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Filtrar unidade</SelectLabel>
          <SelectItem value="all">Todas unidades</SelectItem>
          {unidades.options.map((unidade) => (
            <SelectItem key={unidade.id} value={unidade.id}>
              {unidade.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
